export default __webpack_public_path__ + "af15e45d35a8de4358e90cfbbf8ab342.svg";